/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-home': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(6 6)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M2.092 8.384L9.256 2.46a.382.382 0 01.488 0l7.164 5.924a1.146 1.146 0 001.635-.176 1.206 1.206 0 00-.172-1.671L11.207.613a2.683 2.683 0 00-3.414 0L.633 6.537c-.5.418-.576 1.159-.172 1.671a1.148 1.148 0 001.631.176z"/><path pid="1" d="M17.64 17.417v-5.542a1.761 1.761 0 00-.581-1.259l-6.571-5.541a1.529 1.529 0 00-1.974 0L1.943 10.62a1.76 1.76 0 00-.582 1.254v5.542A1.568 1.568 0 002.91 19h4.264a.784.784 0 00.775-.792v-4.354a.785.785 0 01.775-.791h1.55c.432.005.779.359.775.791v4.354a.784.784 0 00.775.792h4.264a1.568 1.568 0 001.55-1.583z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-home.js